import * as Sentry from "@sentry/react";

let isInitialized = false;

export const init = ({ dsn }) => {
    if (isInitialized) return;

    if (!dsn || dsn === 'production-mode' || dsn.includes('placeholder-dsn')) {
        console.warn('Sentry DSN is missing or invalid. Monitoring disabled.');
        return;
    }

    Sentry.init({
        dsn: dsn,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0,
        // Session Replay
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
    isInitialized = true;
};

export const captureException = (error) => {
    Sentry.captureException(error);
};

export const captureMessage = (message) => {
    Sentry.captureMessage(message);
};
